import * as publicOrders from "../Actions/PublicOrders";

export interface IPublicOrdersState {
  isLoading: boolean;
  orders: any[];
  count: number;
  isError: boolean;
}

export const publicOrdersReducer = (state: IPublicOrdersState = {
  isLoading: false,
  orders: [],
  count: 0,
  isError: false
}, action: any) => {
  switch (action.type) {
    case publicOrders.GET_PUBLIC_ORDERS_DATA_REQUESTED:
      return { ...state, isLoading: true };
    case publicOrders.GET_PUBLIC_ORDERS_DATA_DONE:
      return { ...state, isLoading: false, orders: action.orders, count: action.count};
    case publicOrders.GET_PUBLIC_ORDERS_DATA_FAILED:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};
